<template>
    <div id="subject-choose">
        <div class="header-wrap">
            <div class="header">
                <span class="left"
                      @click="goBack"><i class="icon-fanhui"></i></span>
                <div class="ellipsis">{{titles}}</div>
                <slot></slot>
            </div>
        </div>
        <template v-if="loading">
            <ul class="content"
                v-if='Subject.length'>
                <li @click="toSubject(51,1)"
                    v-if='Subject[0][51] == 51 && Subject.length'>
                    <img src="./img/yw_subject.png" />
                    <span>小学语文</span>
                </li>
                <li @click="toSubject(21,1)"
                    v-if='Subject[0][21]== 21 && Subject.length'>
                    <img src="./img/sx_subject.png" />
                    <span>小学数学</span>
                </li>
                <li @click="toSubject(91,1)"
                    v-if='Subject[0][91] == 91 && Subject.length'>
                    <img src="./img/yy_subject.png" />
                    <span>小学英语</span>
                </li>
                <li @click="toSubject(22,1)"
                    v-if='Subject[0][22] == 22 && Subject.length'>
                    <img src="./img/sx_subject.png" />
                    <span>初中数学</span>
                </li>
                <li @click="toSubject(92,1)"
                    v-if='Subject[0][92] == 92 && Subject.length'>
                    <img src="./img/yy_subject.png" />
                    <span>初中英语</span>
                </li>
                <li @click="toSubject(11,1)"
                    v-if='(Subject[0][11] == 11||Subject[0][14] == 14) && Subject.length'>
                    <img src="./img/sf_subject.png" />
                    <span>爱尚书法</span>
                </li>
                <li @click="toSubject(24,1)"
                    v-if='Subject[0][24] == 24 && Subject.length'>
                    <img src="./img/wq_subject.png" />
                    <span>爱尚围棋</span>
                </li>
                <li @click="toSubject(12,1)"
                    v-if='Subject[0][12] == 12 && Subject.length'>
                    <img src="./img/bc_subject.png" />
                    <span>爱尚编程</span>
                </li>
                <li @click="toSubject(13,1)"
                    v-if='Subject[0][13] == 13 && Subject.length'>
                    <img src="./img/mx_subject.png" />
                    <span>爱尚模型</span>
                </li>
            </ul>
        </template>
        <loadingS v-else></loadingS>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'SRC/components/base/header.vue';
import loadingS from 'SRC/components/base/tealoading.vue';

export default {
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            isInspect: this.$route.params.type,//区分发作业还是检查作业
            titles: '选择学科',
            unitList: {},
            Subject: [],
            loading: false,
            token: localStorage.getItem('Tbkt-Token'),
            is_show: 0, // 激活活动 
            type: 0, // 激活活动 
        }
    },
    computed: {},
    watch: {},
    methods: {
        goBack () {
            if (this.inApp) {
                this.appFunction("ys_finish");
            } else {
                this.$router.push('/');
            }
        },
        toSubject (sub, type) {
            let url;
            if (this.isInspect == 1) {
                // 检查作业
                if (sub === 51) {
                    //小学语文
                    url = '/tea/tasklist'
                } else if (sub === 21) {
                    //小学数学
                    url = '/tea/tasklist'
                } else if (sub === 22) {
                    //初中数学
                    url = '/tea/tasklist'
                } else if (sub === 91) {
                    //小学英语
                    url = '/tea/tasklist'
                } else if (sub === 92) {
                    //初中英语
                    url = '/tea/tasklist'
                } else {
                    //其他
                    url = '/tea/tasklist'
                }
            } else {
                //20241025修改，缓存中不存在search字段时报错
                let { platform, app_version } = localStorage.getItem('search')?JSON.parse(localStorage.getItem('search')):{};
                // 布置作业
                if (sub === 51) {
                    //小学语文
                    url = `/chineseChooseType/51?tbkt_token=${this.token}&platform=${platform}&app_version=${app_version}&v=${(+new Date())}`
                } else if (sub === 21) {
                    //小学数学
                    url = '/mathchooseType/21'
                } else if (sub === 22) {
                    //初中数学
                    url = `${VUE_URL_SX2}/tea/taskset?tbkt_token=${this.token}&platform=${platform}&app_version=${app_version}&v=${(+new Date())}`;
                    if (type == 1) {
                        window.location.href = url;
                    } else {
                        window.location.replace(url + '&is_finish=1')
                    }
                    return false;
                } else if (sub === 91) {
                    //小学英语
                    url = '/englishChooseType/91'
                } else if (sub === 92) {
                    //初中英语
                    url = '/englishChooseType/92'
                } else if (sub === 11 || sub === 12 || sub === 13) {
                    url = `/qualityStation/choosetype/${sub}`
                } else if (sub === 14) {
                    url = `/qualityStation/choosetype/11`
                } else if (sub === 24) {
                    url = `/weiqi/choosetype`
                }
            }
            if (sub === 14) {
                this.toJump(url, type, 2)
            } else {
                this.toJump(url, type)
            }

        },
        toJump (url, type, dept_type) {
            if (dept_type) {
                this.$router.push(`${url}?dept_type=2&type=1&user_type=${this.type}&is_show=${this.is_show}`)
            } else {

                if (type == 1) {
                    this.$router.push(`${url}?type=1&user_type=${this.type}&is_show=${this.is_show}`)
                } else {
                    this.$router.replace(`${url}?user_type=${this.type}&is_show=${this.is_show}`);
                }
            }
        },
    },
    components: {
        headers, loadingS
    },
    mounted () {

    },
    async created () {
        let sub = {};
        await this.$http.post(API_URL_HD_API + '/invite/get_banner').then((res) => {
            if (res.data.response === 'ok') {
                let _r = res.data.data;
                [this.is_show, this.type] = [_r.is_show, _r.type];
            }
        })
        await this.$http.post(API_URL_BASE_API + '/account/profile/').then((res) => {
            if (res.data.response === 'ok') {
                if (res.data.data.units.length < 1) {
                    layer.alert('暂未加入班级', {}, function (index) {
                        layer.close(index);
                    })
                }
                let r = res.data.data;
                localStorage.setItem('info', JSON.stringify(r));
                this.$store.commit('setinfo', r);
                r.units.forEach((m, n) => {
                    if (!sub[m.sid]) {
                        sub[m.sid] = m.sid
                    }
                });
                this.Subject.push(sub);
                if (Object.keys(sub).length === 1) {
                    this.toSubject(parseInt(Object.keys(sub)[0]), 2)
                } else {
                    this.loading = true;
                }

                //把老师所带的科目数存到本地
                localStorage.setItem('subjectLength', Object.keys(this.Subject[0]).length);
            }
        });
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

#subject-choose {
    min-height: 100vh;
    .header-wrap .header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 8;
        height: $h-header;
        line-height: $h-header;
        color: #fff;
        font-size: 34px / $ppr;
        text-align: center;
        background: #5e89ef;
        .icon-fanhui {
            display: block;
            width: 76px / $ppr;
            height: $h-header;
            background-image: url("./img/back.png");
            background-position: center;
            background-size: 18px / $ppr 34px / $ppr;
            background-repeat: no-repeat;
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
        }
        .ellipsis {
            width: 520px / $ppr;
            margin: 0 auto;
        }
    }
    .img {
        width: 100%;
        height: 200px / $ppr;
        img {
            position: fixed;
            top: 96px / $ppr;
            left: 0;
            right: 0;
            width: 100%;
            display: block;
            height: 200px / $ppr;
            z-index: 8;
        }
    }
    .content {
        padding: 0 24px / $ppr 50px / $ppr;
        li {
            margin-top: 32px / $ppr;
            height: 168px / $ppr;
            line-height: 168px / $ppr;
            background: #fff;
            border-radius: 10px / $ppr;
            img {
                margin-left: 24px / $ppr;
                width: 104px / $ppr;
                height: 104px / $ppr;
                vertical-align: middle;
            }
            span {
                margin-left: 32px / $ppr;
                color: #333;
                font-size: 36px / $ppr;
            }
        }
    }
}
</style>
